var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicroscope(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.938.696a1 1 0 0 1 1.366.366l3.093 5.359a1 1 0 0 1-.366 1.366l-.595.344.344.595a1 1 0 1 1-1.732 1l-.344-.595-.595.343a1 1 0 0 1-1.367-.366L5.377 6.742l-.569.322a4.062 4.062 0 0 0-1.369 5.669l.301.451a4.375 4.375 0 0 1 5.824 4.128v.125h5.75a1 1 0 1 1 0 2h-13.5a1 1 0 0 1-1-1v-1.125c0-1.14.445-2.236 1.24-3.052l-.285-.427-.012-.018A6.062 6.062 0 0 1 3.8 5.337l.507.862-.494-.87.563-.32-.727-1.26a1 1 0 0 1 .366-1.365L6.938.696ZM3.893 15.322a2.371 2.371 0 0 0-1.08 1.99v.125h4.75v-.125a2.375 2.375 0 0 0-3.67-1.99ZM6.662 4.968a1.01 1.01 0 0 0-.1-.172l-.681-1.18 1.19-.688 2.094 3.627-.595.344-.595.343-1.313-2.274Zm8.232 5.585a1 1 0 0 1-.447 1.341l-4 2a1 1 0 1 1-.894-1.789l4-2a1 1 0 0 1 1.341.448Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicroscope);
export default __webpack_public_path__ + "static/media/microscope.e4232fe1af858b595a8b21864840abe3.svg";
export { ForwardRef as ReactComponent };